import { Cocktail } from "@/interfaces/Cocktail"
import React, { FC } from "react"
import { FiEdit2 } from "react-icons/fi"
import { Link } from "react-router-dom"
import ToggleInput from "../toggle/Toggle"
import fireIcon from "../../assets/icons/fire.svg"

interface CocktailCardProps {
    title: string,
    cocktails: Cocktail[],
    toggleCocktail: (cocktailId: string, status: string) => void,
    setIsForm?: (params: any) => void
}

const CocktailCard: FC<CocktailCardProps> = ({ title, cocktails, toggleCocktail, setIsForm }) => {
    const formatTitle = (title: string): string => {
        return title
            .split('_')
            .map(word => {
                if (word?.length === 0) return '';
                return word?.charAt(0)?.toUpperCase() + word?.slice(1);
            })
            .join(' ');
    };
    return (
        <div className=" bg-white p-5 rounded-3xl">
            <h1 className="font-semibold text-2xl">{formatTitle(title)}</h1>
            <div className="flex flex-row flex-wrap gap-5 mt-3">
                {cocktails.map((cocktail: Cocktail) =>
                    <div key={cocktail.id} className="overflow-hidden w-28 flex flex-col">
                        <div className="w-28 h-28 overflow-hidden border rounded-xl relative">
                            <img
                                src={cocktail.image}
                                alt={cocktail.name}
                                className="w-full h-full object-cover object-center"
                            />
                            {cocktail.popular && <div className="absolute top-1 left-1" ><img src={fireIcon} className="w-3 h-5" /></div>}
                        </div>
                        <div className="flex flex-col justify-between flex-1 p-2">
                            <p className="font-medium text-[13px] break-words">{cocktail.name}</p>
                            <div className="flex justify-end items-center gap-2 mt-2">
                                {setIsForm ?
                                    <div
                                        onClick={() => setIsForm({
                                            state: "Edit",
                                            tab: "cocktails",
                                            id: cocktail.id,
                                            name: cocktail.name,
                                        })}
                                        className="cursor-pointer flex gap-2 bg-p-gray rounded-full px-2 py-1 items-center text-xs">
                                        <FiEdit2 size={12} />
                                        Edit
                                    </div>
                                    : <Link
                                        to={`/cocktails/${cocktail.id}`}
                                        className="cursor-pointer flex gap-2 bg-p-gray rounded-full px-2 py-1 items-center text-xs">
                                        <FiEdit2 size={12} />
                                        Edit
                                    </Link>}
                                <ToggleInput
                                    onChange={() =>
                                        toggleCocktail(
                                            cocktail.id,
                                            cocktail.status === "active" ? "unavailable" : "active"
                                        )
                                    }
                                    checked={cocktail.status === "active"}
                                />
                            </div>
                        </div>
                    </div>

                )}
            </div>
        </div>
    )
}

export default CocktailCard